import { domains } from 'config/env'
export const TEXT_MANAGE_USERS = 'User Management'
export const USER_MANAGEMENT_PATH = `${domains.ADMIN_DOMAIN}/user-management`
